import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        anbaobinglishow: false,
        danyaokushow: false,
        height:0,
        jiankongshipinshow: false,
        jianyibinglishow: false,
        wurenjishow: false,
    },
    mutations: {
        setheight(state, getheight) {
            state.height = getheight
        },
        anbaobinglishow(state, anbaobinglishow) {
            state.anbaobinglishow = anbaobinglishow
        },
        danyaokushow(state, danyaokushow) {
            state.danyaokushow = danyaokushow
        },
        jiankongshipinshow(state, jiankongshipinshow) {
            state.jiankongshipinshow = jiankongshipinshow
        },
        jianyibinglishow(state, jianyibinglishow) {
            state.jianyibinglishow = jianyibinglishow
        },
        wurenjishow(state, wurenjishow) {
            state.wurenjishow = wurenjishow
        },
    },
    getters: {
        getheight(state, getheight) {
            state.height = getheight
        },
        anbaobinglishow(state) {
            return state.anbaobinglishow
        },
        danyaokushow(state) {
            return state.danyaokushow
        },
        jiankongshipinshow(state) {
            return state.jiankongshipinshow
        },
        jianyibinglishow(state) {
            return state.jianyibinglishow
        },
        wurenjishow(state) {
            return state.wurenjishow
        },
    },
})
